module.exports = __webpack_public_path__ + "img/weixin1-ryxy.ab55b87e.png";